import React, {useEffect, useState} from "react";
import {alertQuestionService} from "../services/alertQuestionService";
import { useHistory } from "react-router-dom";
import { Colors } from "src/assets/colors/Colors";

const clasesColorType = {
    success: "panelColorSuccess",
    warning: "panelColorWarning",
    error: "panelColorError",
    info: "panelColorInfo"
}

const clasesBackgroundType = {
    success: "panelBackgroundSuccess",
    warning: "panelBackgroundWarning",
    error: "panelBackgroundError",
    info: "panelBackgroundInfo"
}

const defaultId = 'defaultAlertQuestion';

const AlertQuestion = ({id = defaultId}) => {

    let history = useHistory();
    const [alertQuestion, setAlertQuestion] = useState(null);

    useEffect(() => {

        const subscription = alertQuestionService.onAlertQuestion(id)
            .subscribe(alertQtion=> {
                if (!alertQtion.message) {
                    setAlertQuestion(null);
                } else {
                    setAlertQuestion(alertQtion);
                }
            });

      const historyUnlisten = history.listen(() => {
            alertQuestionService.clear(id);
      });

        return () => {
            subscription.unsubscribe();
            historyUnlisten();
        };

    }, []);

    if (!alertQuestion) return null;

    return(
        <div className="panel modal is--open">
            <div className="panel__content">
                <div className="panel__content_labels position-relative">
                {
                  alertQuestion.close &&
                    <a onClick={() => {alertQuestionService.clear(id)}} className="icon-container-actions d-flex position-absolute" style={{right: 10, top: 15}}>
                      <div className={clasesBackgroundType[alertQuestion.type]} />
                      <i className={`fas fa-times fa-2x ${clasesColorType[alertQuestion.type]}`}/>
                    </a>
                }
                <h4 className={clasesColorType[alertQuestion.type]}>{alertQuestion.title}</h4>
                <h2>{alertQuestion.question}</h2>
                {
                    alertQuestion.targetPrecios != undefined ? (
                        <p>Ten en cuenta que no se guardarán: <br/> <span style={{fontSize: 20 ,color: 'red', fontWeight: 'bold'}}>{alertQuestion['targetPrecios'].error}</span> registros que presentan error y <br/><span style={{fontSize: 20 ,color: '#4040FF', fontWeight: 'bold'}}>{alertQuestion['targetPrecios'].existente}</span> registros ya existentes.</p>
                    ) : alertQuestion.datos != null ? (
                        <p>{alertQuestion.message[0]} <span style={{fontSize: 18, color: Colors.COLOR_GREEN_DARK, fontWeight: 'bold'}}>{alertQuestion.datos[0]}</span> {alertQuestion.message[1]}</p>
                    ) : (
                        <p>{alertQuestion.message}</p>
                    )
                }

                {alertQuestion.html && alertQuestion.html}

                </div>
                <div className="panel__flaps">
                    <div className={`flap outer flap--left ${clasesBackgroundType[alertQuestion.type]}`}/>
                    {
                      alertQuestion.actionBtnAceptar &&
                        <a className={`flap flap__btn w-100 ${clasesBackgroundType[alertQuestion.type]}`} onClick={alertQuestion.actionBtnAceptar}>{
                          alertQuestion.labelAceptar ? alertQuestion.labelAceptar : 'Aceptar'}</a>
                    }
                    {
                      alertQuestion.actionBtnCancelar &&
                        <a className={`flap flap__btn w-100 ${clasesBackgroundType[alertQuestion.type]}`} onClick={alertQuestion.actionBtnCancelar}>{
                          alertQuestion.labelCancelar ? alertQuestion.labelCancelar : 'Cancelar'}</a>
                    }
                    <div className={`flap outer flap--right ${clasesBackgroundType[alertQuestion.type]}`}/>
                </div>
            </div>
        </div>
    )

}

export { AlertQuestion };
